<template>
  <div id="app">
    <div class="is-login d-flex" v-if="isLogin">
      <div
        class="app-content-right"
        :class="[showText ? 'app-content-right-full' : '']"
      >
        <div class="" v-if="isPrintPage">
          <header-top></header-top>
        </div>
        <div class="content-bottom">
          <transition name="slide-fade">
            <router-view />
          </transition>
        </div>
      </div>
    </div>
    <div class="not-login" v-else>
      <router-view />
    </div>
  </div>
</template>

<script type="text/javascript">
import { mapGetters, mapActions, mapState } from "vuex";
import ls from "local-storage";
import HeaderTop from "@/views/layout/HeaderTop";
// import AuthLogin from "@/AuthLogin";
export default {
  name: "App",
  components: {
    // MenuLeft,
    HeaderTop,
  },
  computed: {
    ...mapGetters("account", ["logged"]),
    ...mapGetters(["path", "full_path"]),
    ...mapState({
      accountInfo: (state) => state.accountInfo,
    }),
    isPrintPage() {
      let route = this.$route.name;
      if (
        route != 'PrintExport' &&
        route != 'print-barcode' &&
        route != 'print-barcode-multi' &&
        route != 'print-tem-multi' &&
        route != 'print-tem' &&
        route != 'print-tem-multi-storage'
      ) {
        return true;
      }
      return false;
      // return this.$route.name != "PrintExport";
    },
  },

  data() {
    return {
      showText: true,
      isLogin: true
    };
  },
  created() {
    this.checkIsLogin();
  },
  mounted() {
    this.checkLoged();
    if(this.path == "") {
      this.$router.push({ name: "home-index" });
    }
  },
  methods: {
    ...mapActions("account", ["getAccountInfo"]),
    checkLoged() {
      // console.log(AuthLogin)
      let authen = ls.get("token");
      if (!authen) {
        if (this.path !== "register") {
          this.$router.push({ name: "account-login" });
        }
      } else {
        if (!this.logged) {
          this.getAccountInfo();
        }
      }
    },

    toggleMenuParent(value) {
      this.showText = value;
    },
    checkIsLogin() {
      let token = ls.get("token");
      this.isLogin = token ? true : false;
    },
  },
  watch: {
    logged(val) {
      this.isLogin = val ? true : false;
    },
  },
};
</script>

<style>
.app-menu-left {
  min-height: 100vh;
  width: 50px;
  background-color: #015d71;
  transition: 0.3s;
}
.app-content-right {
  height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  transition: 0.3s;
}
.app-menu-left-full {
  width: 250px;
  transition: 0.3s;
}
.app-content-right-full {
  width: 100%;
  transition: 0.3s;
}
.app-content-right .header-top {
  background-color: #fff;
  height: 40px;
  background-color: #000935;
}
.app-content-right .menu-top {
  /*height: 80px;*/
  z-index: 10;
}
.app-content-right .content-bottom {
/*  overflow-y: scroll;*/
  height: calc(100vh - 55px);
}

.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(20px);
  opacity: 0;
}
</style>
